// Fonte dati unica per prezzi e finestra Première — Stagione 2027
export const PREMIERE_DEADLINE_LABEL = '31 gennaio 2027';

export const PRICING_2027 = {
  stagionali: {
    feriale: {
      nome: 'Feriale',
      giorni: 'Lunedì – Giovedì · festivi esclusi',
      premiere: 350,
      ordinario: 400,
      lettino: 'Lettino e ombrellone riservati',
    },
    fullClub: {
      nome: 'Full Club',
      giorni: 'Tutti i giorni di apertura della piscina',
      premiere: 490,
      ordinario: 550,
      lettino: 'Lettino e ombrellone riservati',
    },
  },
  mensili: {
    feriale: 140,
    fullClub: 190,
  },
  giornalieri: {
    feriale: 15,
    festivo: 20,
  },
  pomeridiani: {
    feriale: 8,
    festivo: 10,
  },
};

export const INTERESSI_2027 = [
  'Abbonamenti piscina',
  "Palestra all'aperto",
  'Jacuzzi sotto le stelle',
  'Cinema estivo',
];
